var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover-wrap",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"cover-wrap__btn"},[_c('add-green'),_vm._v(" "),(_vm.$store.getters.isDesktop)?_c('span',{staticClass:"ml-8px"},[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }